import PropTypes from 'prop-types';
import React from 'react';

import SelectBase from '../SelectBase';

const AutocompletePreload = ({
  options,
  loadingMessage,
  defaultOption,
  disableFuzzyMatch,
  fuseConfigKeys,
  ...otherProps
}) => {
  let courseUISelect;
  courseUISelect = (
    <SelectBase
      options={options}
      selectedValue={defaultOption}
      disableFuzzyMatch={disableFuzzyMatch}
      fuseConfigKeys={fuseConfigKeys}
      disabled={options.length === 0}
      {...otherProps}
    />
  );
  return courseUISelect;
};

AutocompletePreload.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
  ).isRequired,
  defaultOption: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
  ]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  noOptionsMessage: PropTypes.string.isRequired,
  loadingMessage: PropTypes.string.isRequired,
  creatable: PropTypes.bool,
  chevronIndicator: PropTypes.bool,
  disableFuzzyMatch: PropTypes.bool,
  fuseConfigKeys: PropTypes.arrayOf(PropTypes.string),
};

AutocompletePreload.defaultProps = {
  defaultOption: null,
  creatable: false,
  chevronIndicator: false,
  disableFuzzyMatch: false,
  fuseConfigKeys: ['label'],
};

export default AutocompletePreload;
